(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $2e33a4f4aeb13ba1$export$fea330ef6103f535(button) {
    if (!button) return;
    button.classList.add("is-loading");
}
function $2e33a4f4aeb13ba1$export$4dabcd056c1d895c(button) {
    if (!button) return;
    button.classList.remove("is-loading");
}


var $f503f4e8b4654857$exports = {};
$f503f4e8b4654857$exports = axios;


function $61c28ed01bf7c1d1$export$546f71b8cb2147a0(error) {
    if (error.response) {
        if (error.response.data) {
            if (error.response.data.message) return error.response.data.message;
            if (error.response.data.data) return error.response.data.data;
        }
    }
    if (error.message) return error.message;
    return "An unknown error occurred.";
}
function $61c28ed01bf7c1d1$export$834dfce7b095c052(response) {
    if (!response.data) return "Something went wrong.";
    if (!response.data.data && !response.data.message) return "Something went wrong.";
    if (response.data.message) return response.data.message;
    return response.data.data;
}


async function $637b63e67ce49013$export$a371bddf5e7fb880(formData) {
    try {
        const axiosResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports)))({
            method: "post",
            url: pm.ajaxurl,
            data: formData
        });
        return axiosResponse.data;
    } catch (error) {
        const msg = (0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports))).isAxiosError(error) ? (0, $61c28ed01bf7c1d1$export$546f71b8cb2147a0)(error) : "An unknown error occurred.";
        return {
            success: false,
            message: msg
        };
    }
}


function $151b7e749519389d$export$610baa84dfb8346d(form) {
    const { emptyElement: emptyElement } = pm.utils.dom;
    const notice = pm.utils.notice;
    const submitButton = form.querySelector('button[type="submit"]');
    if (!submitButton) return;
    const fieldsGroup = form.querySelector(".mailerlite-form-inputs");
    if (!fieldsGroup) return;
    const nameField = form.querySelector('[name="name"]');
    if (!nameField) return;
    const emailField = form.querySelector('[name="email"]');
    if (!emailField) return;
    const submissionResponse = form.querySelector(".submission-response");
    if (!submissionResponse) return;
    const useRecaptcha = form.dataset.useRecaptcha === "1";
    form.addEventListener("submit", handleFormSubmission);
    let doingAjax = false;
    async function handleFormSubmission(ev) {
        ev.preventDefault();
        if (doingAjax) return;
        doingAjax = true;
        notice.hide(submissionResponse, true);
        if (submitButton) (0, $2e33a4f4aeb13ba1$export$fea330ef6103f535)(submitButton);
        if (!window["pmRunRecaptchaAjaxForm"]) {
            alert("missing grecaptcha");
            return;
        }
        if (useRecaptcha) {
            pmRunRecaptchaAjaxForm("contact_form_submission", submitWithToken);
            return;
        }
        await submitWithToken("");
    }
    async function submitWithToken(recaptchaToken) {
        const formData = new FormData(form);
        if (useRecaptcha) formData.append("recaptcha_token", recaptchaToken);
        const response = await (0, $637b63e67ce49013$export$a371bddf5e7fb880)(formData);
        doingAjax = false;
        (0, $2e33a4f4aeb13ba1$export$4dabcd056c1d895c)(submitButton);
        if (!response.success) {
            notice.show(submissionResponse, response.message ?? "An unknown error occurred.", "failed", true);
            return;
        }
        const successMsg = response.message ?? response.data;
        notice.show(submissionResponse, successMsg, "success", true);
        if (fieldsGroup) emptyElement(fieldsGroup);
    }
}


(function() {
    const forms = document.querySelectorAll("form.subscribe-form");
    if (!forms.length) return;
    forms.forEach(function(form) {
        (0, $151b7e749519389d$export$610baa84dfb8346d)(form);
    });
})();

})();
//# sourceMappingURL=subscribe-form.js.map
